var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "basic-container",
    [
      _c(
        "div",
        { staticClass: "search-contain" },
        [
          _c(
            "el-form",
            {
              ref: "query",
              attrs: { model: _vm.query, inline: true, size: "mini" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "中奖时间", prop: "daterange" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "220px" },
                    attrs: {
                      format: "yyyy-MM-dd",
                      "value-format": "yyyy-MM-dd",
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                    },
                    model: {
                      value: _vm.daterange,
                      callback: function ($$v) {
                        _vm.daterange = $$v
                      },
                      expression: "daterange",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "奖品名称" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "输入奖品名称或ID", clearable: "" },
                    model: {
                      value: _vm.query.prize,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.query,
                          "prize",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "query.prize",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "用户" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "输入用户手机号或 ID",
                      clearable: "",
                    },
                    model: {
                      value: _vm.query.user,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.query,
                          "user",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "query.user",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "关联活动" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "输入活动名称或 ID", clearable: "" },
                    model: {
                      value: _vm.query.event,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.query,
                          "event",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "query.event",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "领取情况", prop: "status" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择", clearable: "" },
                      model: {
                        value: _vm.query.isGet,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "isGet", $$v)
                        },
                        expression: "query.isGet",
                      },
                    },
                    _vm._l(_vm.statusList, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-search",
                        loading: _vm.loading,
                      },
                      on: { click: _vm.search },
                    },
                    [_vm._v("筛选")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "danger",
                        icon: "el-icon-delete",
                        loading: _vm.loading,
                      },
                      on: { click: _vm.reset },
                    },
                    [_vm._v("清空")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "yd-table",
        {
          attrs: {
            loading: _vm.loading,
            data: _vm.records,
            border: "",
            size: "mini",
            pagination: _vm.pagination,
          },
          on: { onChange: _vm.onTableChange },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "中奖ID",
              prop: "id",
              align: "center",
              width: "100",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "用户信息", align: "center", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [_vm._v(_vm._s(scope.row.userId))]),
                    _c("div", [_vm._v(_vm._s(scope.row.userPhone))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "奖品名称",
              prop: "prizesName",
              align: "center",
              "min-width": "300",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "价值",
              prop: "price",
              align: "center",
              width: "120",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(" " + _vm._s(scope.row.price / 100) + "元 ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "关联活动",
              prop: "raffleName",
              align: "center",
              "min-width": "300",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "中奖时间",
              prop: "prizeDate",
              align: "center",
              width: "300",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "领取情况",
              prop: "isGet",
              align: "center",
              width: "120",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.isGet === 1
                      ? _c("div", [
                          _vm._v("\n          已领取\n          "),
                          _c("div", [_vm._v(_vm._s(scope.row.isGetDate))]),
                        ])
                      : _c("div", [_vm._v("未领取")]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }